import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeader = () => {
  const token = localStorage.getItem('adminToken');
  return { Authorization: `Bearer ${token}` };
};

// Videos
export const getVideos = async (params) => {
  const response = await axios.get(`${API}/admin/videos`, {
    params,
    headers: getAuthHeader()
  });
  return response.data;
};

export const createVideo = async (data) => {
  const response = await axios.post(`${API}/admin/videos`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const updateVideo = async (id, data) => {
  const response = await axios.put(`${API}/admin/videos/${id}`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const deleteVideo = async (id) => {
  const response = await axios.delete(`${API}/admin/videos/${id}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Coupons
export const getCoupons = async () => {
  const response = await axios.get(`${API}/admin/coupons`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const createCoupon = async (data) => {
  const response = await axios.post(`${API}/admin/coupons`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const updateCoupon = async (id, data) => {
  const response = await axios.put(`${API}/admin/coupons/${id}`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const deleteCoupon = async (id) => {
  const response = await axios.delete(`${API}/admin/coupons/${id}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Blogs
export const getBlogs = async () => {
  const response = await axios.get(`${API}/admin/blogs`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const createBlog = async (data) => {
  const response = await axios.post(`${API}/admin/blogs`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const updateBlog = async (id, data) => {
  const response = await axios.put(`${API}/admin/blogs/${id}`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const deleteBlog = async (id) => {
  const response = await axios.delete(`${API}/admin/blogs/${id}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Excellence
export const getExcellence = async () => {
  const response = await axios.get(`${API}/admin/excellence`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const createExcellence = async (data) => {
  const response = await axios.post(`${API}/admin/excellence`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const updateExcellence = async (id, data) => {
  const response = await axios.put(`${API}/admin/excellence/${id}`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const deleteExcellence = async (id) => {
  const response = await axios.delete(`${API}/admin/excellence/${id}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Locations
export const getAdminLocations = async () => {
  const response = await axios.get(`${API}/admin/locations`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const createLocation = async (data) => {
  const response = await axios.post(`${API}/admin/locations`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const updateLocation = async (id, data) => {
  const response = await axios.put(`${API}/admin/locations/${id}`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const deleteLocation = async (id) => {
  const response = await axios.delete(`${API}/admin/locations/${id}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Gallery
export const getAdminGallery = async () => {
  const response = await axios.get(`${API}/admin/gallery`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const createGalleryItem = async (data) => {
  const response = await axios.post(`${API}/admin/gallery`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const updateGalleryItem = async (id, data) => {
  const response = await axios.put(`${API}/admin/gallery/${id}`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const deleteGalleryItem = async (id) => {
  const response = await axios.delete(`${API}/admin/gallery/${id}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

// Testimonials
export const getAdminTestimonials = async () => {
  const response = await axios.get(`${API}/admin/testimonials`, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const createTestimonial = async (data) => {
  const response = await axios.post(`${API}/admin/testimonials`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const updateTestimonial = async (id, data) => {
  const response = await axios.put(`${API}/admin/testimonials/${id}`, data, {
    headers: getAuthHeader()
  });
  return response.data;
};

export const deleteTestimonial = async (id) => {
  const response = await axios.delete(`${API}/admin/testimonials/${id}`, {
    headers: getAuthHeader()
  });
  return response.data;
};

// File Upload
export const uploadFile = async (file, type = 'images') => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', type);
  
  const response = await axios.post(`${API}/admin/upload`, formData, {
    headers: {
      ...getAuthHeader(),
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const deleteFile = async (fileUrl) => {
  const response = await axios.delete(`${API}/admin/upload`, {
    data: { fileUrl },
    headers: getAuthHeader()
  });
  return response.data;
};
